import DepartmentCard from './DepartmentCard.gql';

export default DepartmentCard;
